module.exports = __webpack_public_path__ + "img/cause_8.5b0ee2b6.png";